import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { IMAGE } from 'common/endpoints'
import StyledVirtualHottieTag from './StyledVirtualHottieTag'

const VirtualHottieTag = () => (
  <StyledVirtualHottieTag>
    <span className="tooltip-wrapper">
      <img className="virtual-hottie" src={IMAGE.basic('virtual_hottie@2x.png')} />
      <span className="tooltip-text">
        I'm an Automated profile. For more information on Automated Profiles, please refer to the
        <Link to="/terms"> Terms And Conditions</Link>.
      </span>
    </span>
  </StyledVirtualHottieTag>
)
export default connect(p => p.siteConfig)(VirtualHottieTag)
